import { atom } from 'jotai';

import { SUPPORT_BOT_LINK } from '@/lib/constants/link.ts';

export const topNavigationInquiryLinkAtom = atom(SUPPORT_BOT_LINK.default);
